(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jk-office"] && !Shopify.designMode) return;
  try {
    
  const refreshDigitalDates = () => {
    const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
    const part = (type) => parts.find((value) => value.type === type)?.value;
    const today = part('year') + '-' + part('month') + '-' + part('day');
    document.querySelectorAll('[data-jk-deadline]').forEach((element) => {
      const deadline = element.dataset.jkDeadline;
      element.textContent = deadline < today ? element.dataset.overdue : deadline === today ? element.dataset.today : '';
    });
  };
  refreshDigitalDates();
  document.addEventListener('shopify:section:load', refreshDigitalDates);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) refreshDigitalDates();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jk-project-archive"] && !Shopify.designMode) return;
  try {
    
  if (!window.jkProjectDirectoryReady) {
    window.jkProjectDirectoryReady = true;

    const updateJkProjectDirectory = function (directory) {
      const search = directory.querySelector('[data-jk-project-search]');
      const clear = directory.querySelector('[data-jk-project-search-clear]');
      const activeFilter = directory.querySelector('[data-jk-project-filter][aria-pressed="true"]');
      const filter = activeFilter ? activeFilter.dataset.jkProjectFilter : 'all';
      const query = search ? search.value.trim().toLocaleLowerCase() : '';
      let visibleProjects = 0;
      let visiblePages = 0;

      directory.querySelectorAll('[data-jk-project-category]').forEach(function (card) {
        const categoryMatches = filter === 'all' || card.dataset.jkProjectCategory.split(/\s+/).includes(filter);
        const searchMatches = !query || card.textContent.toLocaleLowerCase().includes(query);
        const show = categoryMatches && searchMatches;
        card.hidden = !show;
        if (show) visibleProjects += 1;
      });

      directory.querySelectorAll('.jk-project-library__links li').forEach(function (item) {
        const show = !query || item.textContent.toLocaleLowerCase().includes(query);
        item.hidden = !show;
        if (show) visiblePages += 1;
      });

      directory.querySelectorAll('.jk-project-library__group').forEach(function (group) {
        group.hidden = !group.querySelector('.jk-project-library__links li:not([hidden])');
      });

      if (clear) clear.disabled = !query;
      const status = directory.querySelector('[data-jk-project-status]');
      if (status) {
        const projectLabel = visibleProjects === 1 ? ' project record' : ' project records';
        const pageLabel = visiblePages === 1 ? ' supporting page' : ' supporting pages';
        status.textContent = 'Showing ' + visibleProjects + projectLabel + ' and ' + visiblePages + pageLabel;
      }
      const empty = directory.querySelector('[data-jk-project-empty]');
      if (empty) empty.hidden = visibleProjects + visiblePages > 0;
    };

    const initialiseJkProjectDirectories = function (scope) {
      scope.querySelectorAll('[data-jk-project-directory]').forEach(updateJkProjectDirectory);
    };

    document.addEventListener('click', function (event) {
      const filterButton = event.target.closest('[data-jk-project-filter]');
      if (filterButton) {
        const directory = filterButton.closest('[data-jk-project-directory]');
        if (!directory) return;
        directory.querySelectorAll('[data-jk-project-filter]').forEach(function (item) {
          item.setAttribute('aria-pressed', String(item === filterButton));
        });
        updateJkProjectDirectory(directory);
        return;
      }

      const clearButton = event.target.closest('[data-jk-project-search-clear]');
      if (!clearButton) return;
      const directory = clearButton.closest('[data-jk-project-directory]');
      if (!directory) return;
      const search = directory.querySelector('[data-jk-project-search]');
      if (!search) return;
      search.value = '';
      updateJkProjectDirectory(directory);
      search.focus();
    });

    document.addEventListener('input', function (event) {
      if (!event.target.matches('[data-jk-project-search]')) return;
      const directory = event.target.closest('[data-jk-project-directory]');
      if (directory) updateJkProjectDirectory(directory);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initialiseJkProjectDirectories(document);
      });
    } else {
      initialiseJkProjectDirectories(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initialiseJkProjectDirectories(event.target);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
